import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, InputGroup, FormControl } from 'react-bootstrap'
import FaIcon from './fa_icon'

const { Addon } = InputGroup

class GlgTextInput extends PureComponent {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
    this.onReset = this.onReset.bind(this)

    // Debounce needed props
    this.state = { value: props.value }
    this.debounceTimer = null

  }

  componentDidMount() {
    // Edge case: slightly delay the focus while the popup is appearing
    setTimeout(() => {
      if (this.props.focusOnMount && this.inputRef) {
        this.inputRef.focus()
      }
    }, 10)
  }

  componentDidUpdate(prevProps) {
    if (this.props.debounceSpan && prevProps.value !== this.props.value && this.props.value !== this.state.value) {
      clearTimeout(this.debounceTimer)
      this.setState({ value: this.props.value })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.debounceTimer)
  }

  onChange(event) {
    // TODO: Use a debounce hook instead when migrating this
    // Debounced path
    if (this.props.debounceSpan && this.props.onChange) {
      const value = event.target.value
      // Update display immediately
      this.setState({ value })

      // Clear previous timer
      clearTimeout(this.debounceTimer)

      // Set new timer
      this.debounceTimer = setTimeout(() => {
        this.props.onChange(value)
      }, this.props.debounceSpan) // Custom delay

      return
    }

    if (this.props.onChange) {
      this.props.onChange(event.target.value)
    }
  }
  
  onKeyPress(event) {
    if (event.charCode === 13) {
      if (this.props.onKeyPress) {
        this.props.onKeyPress(event.target.value)
      }
    }
  }

  onReset() {
    if (this.props.onChange) {
      if (this.props.debounceSpan) {
        this.setState({ value: '' })
      }

      this.props.onChange('')
    }
    this.inputRef.focus()
  }

  render() {
    // When using debounce, the actual value that is shown by the input is a little bit ahead of the value passed by props
    const displayedValue = this.props.debounceSpan ? this.state.value : this.props.value

    let textInput = (
      <FormControl
        type="text"
        value={ displayedValue }
        placeholder={ this.props.placeholder }
        onChange={ this.onChange }
        inputRef={ ref => { this.inputRef = ref } }
        onKeyPress={ this.onKeyPress }
        required={ this.props.required }
        disabled={ this.props.disabled }
      />
    )

    if (this.props.withAddon) {
      textInput = (
        <InputGroup>
          { textInput }
          <Addon
            onClick={ this.onReset }
            className="clickable"
          >
            <a>
              <FaIcon icon="eraser" />
            </a>
          </Addon>
        </InputGroup>
      )
    }

    return (
      <FormGroup className="glg-text-input">
        { textInput }
      </FormGroup>
    )
  }
}

GlgTextInput.propTypes = {
  // The controlled value of the text input
  value: PropTypes.string,
  // Callback when the input value changes
  onChange: PropTypes.func,
  // Callback when enter is pressed
  onKeyPress: PropTypes.func,
  // If true, it will render the erase icon to the right of the text input
  withAddon: PropTypes.bool,
  // Text input placeholder
  placeholder: PropTypes.string,
  // If true, the text input will be focused after mounting the component
  focusOnMount: PropTypes.bool,
  // If true, the text input will be required
  required: PropTypes.bool,
  // If set to a positive integer, it will activate the debounce mechanism and use this as the timer (milliseconds)
  debounceSpan: PropTypes.number,
  // If the select is disabled, false by default
  disabled: PropTypes.bool,
}

GlgTextInput.defaultProps = {
  withAddon: false,
  placeholder: !window.I18n ? '' : window.I18n.t('shared.components.glg_text_input.search'),
  focusOnMount: false,
  required: false,
}

export default GlgTextInput
